import axios from "axios";

const getApiBaseUrl = () => {
  // return "http://192.168.0.107:5001/api/";
  return "https://app.topupconnect.in/restapi/";
};

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Dynamically update baseURL and token before each request
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  const baseURL = getApiBaseUrl();

  config.baseURL = baseURL;

  if (token) {
    config.headers["x-access-token"] = `${token}`;
  }

  return config;
});

export default axiosInstance;
